<div class="container">
  <div class="row">
    <div class="title-container d-flex col-12 mb-3">
      <div class="dashboard__title">
        <h2 uni-heading weight="semibold" color="primary">Resumen de Productos</h2>
      </div>
      <div class="desktop-content">
        <div class="d-flex align-items-center">
          <span class="pr-3">Seleccionar: </span>
          <img
            *ngIf="products.length > 1"
            class="config-icon-button"
            (click)="openConfigModal()"
            src="/assets/images/config-icon.svg"
            alt="config-item"
          />
          <div class="buttons-group">
            <a [routerLink]="['/portales/dashboard/salud']" routerLinkActive="active">Salud Local</a>
            <a [routerLink]="['/portales/dashboard/rgvsi']" routerLinkActive="active">Riesgos Generales</a>
            <a [routerLink]="['/portales/dashboard/afi']" routerLinkActive="active">Fondos de Inversión</a>
          </div>
        </div>
      </div>
      <div class="mobile-content">
        <div class="dropdown-title" dropdown>
          <button
            (click)="showUlList()"
            type="button"
            class="menu-dropdown-button dropdown-toggle"
            aria-controls="dropdown-basic"
          >
            {{ currentOption }}
          </button>

          <div #invisibleDiv [hidden]="isShowingUlList" class="dropdown-content">
            <ul>
              <li role="menuitem">
                <a
                  [routerLink]="['/portales/dashboard/salud']"
                  class="dropdown-item"
                  (click)="setCurrentOption('Salud local')"
                  routerLinkActive="active"
                  >Salud Local</a
                >
              </li>
              <li role="menuitem">
                <a
                  [routerLink]="['/portales/dashboard/rgvsi']"
                  class="dropdown-item"
                  (click)="setCurrentOption('Riesgos generales')"
                  routerLinkActive="active"
                  >Riesgos Generales</a
                >
              </li>
              <li role="menuitem">
                <a
                  [routerLink]="['/portales/dashboard/afi']"
                  class="dropdown-item"
                  (click)="setCurrentOption('Fondos de inversión')"
                  routerLinkActive="active"
                  >Fondos de Inversión</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
